import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Model,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.catalog}models/bySearchModel`;

interface GetRepairableByModelIdPayload {
  maxResult: number;
  searchTerms: string;
  sellerId: string;
}

async function getModelsBySearchModelQuery({
  maxResult,
  searchTerms,
  sellerId,
}: GetRepairableByModelIdPayload): Promise<
  BackResponse<Model[]> | BackResponseFailure
> {
  try {
    const response = await apiCall<BackResponse<Model[]>>(
      buildUrl(ENDPOINT, { maxResult, searchTerms, sellerId }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getModelsBySearchModelQuery;
